import React from 'react';

const CancellationRefundPolicy = () => {
  return (
    <div className="compalinace-page" style={{ background: '#0a1d38', fontFamily: 'Lato, sans-serif' }}>
      <div className="compalinace-content" style={{ background: '#ffffff', borderRadius: '32px 32px 0 0', padding: '32px 24px' }}>
        <div className="content-container" style={{ margin: '0 auto', maxWidth: '1000px' }}>
          <p className="content-head" style={{ fontSize: '24px', lineHeight: '30px', color: '#213554', margin: '0', fontWeight: 700 }}>
            Cancellation & Refund Policy
          </p>
          <div className="content-seprater" style={{ width: '28px', height: '5px', backgroundColor: '#213554', marginTop: '16px' }}></div>
          <p className="updated-date" style={{ margin: '16px 0 0', color: '#213554ab', fontWeight: 700 }}>Last updated on Feb 20th 2025</p>
          <p className="content-text" style={{ color: '#515978', margin: '16px 0 0', fontSize: '14px', lineHeight: '20px' }}>
            Rx Pharma believes in helping its customers as far as possible, and has therefore a liberal cancellation policy. Under this policy:
          </p>
          <ul className="unorder-list" style={{ margin: '0', paddingLeft: '20px' }}>
            <li className="list-item" style={{ listStyleType: 'disc', paddingLeft: '5px' }}>
              <p className="content-text list-text">
                Cancellations will be considered only if the request is made within 7 days of placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.
              </p>
            </li>
            <li className="list-item" style={{ listStyleType: 'disc', paddingLeft: '5px' }}>
              <p className="content-text list-text">
                Rx Pharma does not accept cancellation requests for perishable items like flowers, eatables etc. However, refund/replacement can be made if the customer establishes that the quality of product delivered is not good.
              </p>
            </li>
            <li className="list-item" style={{ listStyleType: 'disc', paddingLeft: '5px' }}>
              <p className="content-text list-text">
                In case of receipt of damaged or defective items please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at his own end. This should be reported within 7 days of receipt of the products.
              </p>
            </li>
            <li className="list-item" style={{ listStyleType: 'disc', paddingLeft: '5px' }}>
              <p className="content-text list-text">
                In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within 7 days of receiving the product. The Customer Service Team after looking into your complaint will take an appropriate decision.
              </p>
            </li>
            <li className="list-item" style={{ listStyleType: 'disc', paddingLeft: '5px' }}>
              <p className="content-text list-text">
                In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them.
              </p>
            </li>
            <li className="list-item" style={{ listStyleType: 'disc', paddingLeft: '5px' }}>
              <p className="content-text list-text">
                In case of any Refunds approved by the Rx Pharma, it’ll take 6-8 days for the refund to be processed to the end customer.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CancellationRefundPolicy;